import React from "react"

import { ProductConfiguratorProps } from "../../ProductConfigurator"
import { useProductConfiguratorAddonsViewModel } from "../../model/useProductConfiguratorAddonsViewModel"
import { ProductConfiguratorAddonsView } from "./ProductConfiguratorAddonsView"

export type ProductConfiguratorAddonsProps = Pick<
  ProductConfiguratorProps,
  "addonOptions" | "onAddonDelete"
>

export const ProductConfiguratorAddons = React.memo(
  (props: ProductConfiguratorAddonsProps) => {
    return (
      <ProductConfiguratorAddonsView
        {...useProductConfiguratorAddonsViewModel(props)}
      />
    )
  }
)
